import FindTheLetter from './FindTheLetter';
import FindTheObjects from './FindTheObjects';
import SoundOutWords from './SoundOutWords';

export default {
  FindTheLetter,
  FindTheObjects,
  SoundOutWords,
};
